export default "__VITE_ASSET__Uv4I4uD1__"